export const handleRandomNumber=()=>{
  return  Math.floor(Math.random() * 6) + 5;
}